export const ROLES = ["STUDENT", "TEACHER"];
